import { create } from "zustand";
import { IUserBusiness } from "@/types/user.types";
import selectColorTypeBusiness from "@/components/common/selectColorTypeBusiness";
import { hours24, hoursAmPm } from "@/components/common/hours";

export const useUserBusinessPage = create<IUserBusiness>((set) => ({
  data: {
    about_us: "",
    description: "",
    showUploadOwn: false,
    showUploadOwnLogo: false,
    svgColor: "",
    website: "",
    app_name: "",
    developer: "",
    logo: "",
    name: "",
    dynamic: "1",
    hours_type: "am/pm",
    design_colors_primary: selectColorTypeBusiness[0].color,
    design_colors_button: selectColorTypeBusiness[0].buttonColor,
    image: "",
    image_name: "",
    image_type: "",
    image_path: "",
    welcome_screen: "",
    welcome_path: "",
    company: "",
    headline: "",
    summary: "",
    button: "",
    button_url: "",
    opening_hours: [
      {
        day: "Monday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Tuesday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Wednesday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Thursday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Friday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Saturday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
      {
        day: "Sunday",
        hours: [
          {
            start: "12:00 am",
            end: "12:00 pm",
          },
        ],
        active: false,
      },
    ],
    street_number: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    venue_amenities: [],
    about: "",
    contact_name: "",
    phone: "",
    email: "",
    website_url: "",
    longitude: -73.9855426,
    latitude: 40.7579747,
    address: "",
    street: "",
    showButton: false,
    socialItems: [],
    showMoreAddress: false,
  },
  addButton: [
    {
      value: "Buy now",
      icon: "",
    },
    {
      value: "Learn more",
      icon: "",
    },
    {
      value: "Shop online",
      icon: "",
    },
    {
      value: "View all items",
      icon: "",
    },
    {
      value: "Custom",
      icon: "/common/edit-icon.svg",
    },
  ],
  socialTypes: [
    {
      icon: "/social-items/website.svg",
      text: "Website",
      active: false,
      type: "website",
    },
    {
      icon: "/social-items/facebook.svg",
      text: "Facebook",
      active: false,
      type: "facebook",
    },
    {
      icon: "/social-items/twitter.svg",
      text: "Twitter",
      active: false,
      type: "twitter",
    },
    {
      icon: "/social-items/instagram.svg",
      text: "Instagram",
      active: false,
      type: "instagram",
    },
    {
      icon: "/social-items/linkedin.svg",
      text: "Linkedin",
      active: false,
      type: "linkedin",
    },
    {
      icon: "/social-items/youtube.svg",
      text: "Youtube",
      active: false,
      type: "youtube",
    },
    {
      icon: "/social-items/wp.svg",
      text: "Whatsapp",
      active: false,
      type: "whatsapp",
    },
    {
      icon: "/social-items/tg.svg",
      text: "Telegram",
      active: false,
      type: "telegram",
    },
    {
      icon: "/social-items/snap.svg",
      text: "Snapchat",
      active: false,
      type: "snapchat",
    },
    {
      icon: "/social-items/tiktok.svg",
      text: "Tiktok",
      active: false,
      type: "tiktok",
    },
  ],
  showMoreContact: false,
  config: {},
  setChangeHoursType: (val) => {
    set((state) => {
      if (val === "24h") {
        state.data?.opening_hours?.forEach((item) => {
          item.hours?.forEach((_hours) => {
            const currentStart = _hours?.start;
            const currentEnd = _hours?.end;

            _hours.start = hours24[0].hours;
            _hours.end = hours24.at(-1)!.hours;

            if (currentStart) {
              _hours.start = hours24[hoursAmPm.findIndex((h) => h.hours === currentStart)]?.hours;
            }
            if (currentEnd) {
              _hours.end = hours24[hoursAmPm.findIndex((h) => h.hours === currentEnd)]?.hours;
            }
          });
        });
      } else {
        state.data?.opening_hours?.forEach((item) => {
          item.hours?.forEach((_hours) => {
            const currentStart = _hours?.start;
            const currentEnd = _hours?.end;

            _hours.start = hoursAmPm[0]?.hours;
            _hours.end = hoursAmPm.at(-1)!.hours;

            if (currentStart) {
              _hours.start = hoursAmPm[hours24.findIndex((h) => h.hours === currentStart)]?.hours;
            }
            if (currentEnd) {
              _hours.end = hoursAmPm[hours24.findIndex((h) => h.hours === currentEnd)]?.hours;
            }
          });
        });
      }

      return { ...state };
    });
  },
  setUserParams: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setConfig: (val) =>
    set((state) => ({
      ...state,
      config: { ...state.config, val },
    })),
  setUserBusiness: (val, type, from) => {
    set((state) => {
      if (type === "social") {
        return {
          ...state,
          data: {
            ...state.data,
            [from!]: {
              ...(state.data[from!] as object),
              ...val,
            },
          },
        };
      }

      return { ...state, data: { ...state.data, ...val } };
    });
  },
  setDeleteUserBusiness: (val) => {
    set((state) => {
      delete state.data[val];

      return { ...state };
    });
  },
  setOpeningHours: (val, type) => {
    set((state) => {
      if (type === "fromItems") {
        if (val.hours.start !== undefined) {
          state.data.opening_hours[val.dayIndex].hours[val.hoursIndex].start = val.hours.start;
        } else if (val.hours.end !== undefined) {
          state.data.opening_hours[val.dayIndex].hours[val.hoursIndex].end = val.hours.end;
        }
      } else if (type === "fromSwitch") {
        state.data.opening_hours[val.parentIndex].active = val.active;
      } else if (type === "fromAddButton") {
        if (state.data.opening_hours[val.parentIndex].hours.length < 2) {
          state.data.opening_hours[val.parentIndex].hours.push(val.hours);
        }
      } else if (type === "fromDeleteButton") {
        state.data.opening_hours[val]?.hours.splice(1, 1);
      }

      return { ...state };
    });
  },
  setReorderSocial: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          socialItems: val,
        },
      };
    });
  },
  setDeleteSocialItem: (index) => {
    set((state) => {
      const afterDeleted = state.data.socialItems.filter((e, i) => {
        return i !== index;
      });
      return {
        ...state,
        data: {
          ...state.data,
          socialItems: afterDeleted,
        },
      };
    });
  },
  setSocialItems: (val, type, index, action) => {
    set((state) => {
      if (type === "add") {
        return {
          ...state,
          data: {
            ...state.data,
            socialItems: [...state.data.socialItems, val],
          },
        };
      }
      if (type === "update_value" && action) {
        (state.data.socialItems[index] as any)[action] = val;
        return { ...state };
      } else {
        return { ...state, socialItems: val };
      }
    });
  },
  setSocialTypes: (val) => {
    set((state) => {
      const newSocialTypesState = state.socialTypes.map((obj) => {
        if (
          obj.type.toUpperCase().replace(/\s+/g, "") === val.type.toUpperCase().replace(/\s+/g, "")
        ) {
          return { ...obj, active: val.active };
        }

        return obj;
      });

      return { ...state, socialTypes: newSocialTypesState };
    });
  },
  setDeleteSocialTypes: (val) => {
    set((state) => {
      const deleted = state.data.socialItems.filter(
        (e) =>
          e.type.toUpperCase().replace(/\s+/g, "") !== val.type.toUpperCase().replace(/\s+/g, ""),
      );

      return {
        ...state,
        data: {
          ...state.data,
          socialItems: deleted,
        },
      };
    });
  },
  setShowButton: (val) => {
    set((state) => {
      return { ...state, data: { ...state.data, showButton: val } };
    });
  },
  setShowMoreAddress: (val) => {
    set((state) => {
      return {
        ...state,
        data: {
          ...state.data,
          showMoreAddress: val,
          address: val ? "" : state.data.address,
        },
      };
    });
  },
  setShowMoreContact: (val) => {
    set((state) => {
      return { ...state, showMoreContact: val };
    });
  },
  setAmenties: (val) => {
    set((state) => {
      if (state.data.venue_amenities.find((e) => e.type === val.type) === undefined) {
        return {
          ...state,
          data: {
            ...state.data,
            venue_amenities: [...state.data.venue_amenities, val],
          },
        };
      } else {
        const filtered = state.data.venue_amenities.filter((e) => e.type !== val.type);

        return {
          ...state,
          data: {
            ...state.data,
            venue_amenities: filtered,
          },
        };
      }
    });
  },
  destroyUserBusiness: () => {
    set(() => {
      return {
        data: {
          name: "",
          dynamic: "1",
          hours_type: "am/pm",
          design_colors_primary: selectColorTypeBusiness[0].color,
          design_colors_button: selectColorTypeBusiness[0].buttonColor,
          image: "",
          image_name: "",
          image_type: "",
          image_path: "",
          welcome_screen: "",
          welcome_path: "",
          company: "",
          headline: "",
          summary: "",
          button: "",
          button_url: "",
          opening_hours: [
            {
              day: "Monday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
            {
              day: "Tuesday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
            {
              day: "Wednesday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
            {
              day: "Thursday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
            {
              day: "Friday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
            {
              day: "Saturday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
            {
              day: "Sunday",
              hours: [
                {
                  start: "12:00 am",
                  end: "12:00 pm",
                },
              ],
              active: false,
            },
          ],
          street_number: "",
          city: "",
          state: "",
          zip: "",
          country: "",
          venue_amenities: [],
          about: "",
          contact_name: "",
          phone: "",
          email: "",
          website_url: "",
          longitude: -73.9855426,
          latitude: 40.7579747,
          address: "",
          street: "",
          showButton: false,
          socialItems: [],
          showMoreAddress: false,
        },
        addButton: [
          {
            value: "Buy now",
            icon: "",
          },
          {
            value: "Learn more",
            icon: "",
          },
          {
            value: "Shop online",
            icon: "",
          },
          {
            value: "View all items",
            icon: "",
          },
          {
            value: "Custom",
            icon: "/common/edit-icon.svg",
          },
        ],
        socialTypes: [
          {
            id: 0,
            icon: "/social-items/website.svg",
            text: "Website",
            active: false,
            type: "website",
          },
          {
            id: 1,
            icon: "/social-items/facebook.svg",
            text: "Facebook",
            active: false,
            type: "facebook",
          },
          {
            id: 2,
            icon: "/social-items/twitter.svg",
            text: "Twitter",
            active: false,
            type: "twitter",
          },
          {
            id: 3,
            icon: "/social-items/instagram.svg",
            text: "Instagram",
            active: false,
            type: "instagram",
          },
          {
            id: 4,
            icon: "/social-items/linkedin.svg",
            text: "Linkedin",
            active: false,
            type: "linkedin",
          },
          {
            id: 5,
            icon: "/social-items/youtube.svg",
            text: "Youtube",
            active: false,
            type: "youtube",
          },
          {
            id: 6,
            icon: "/social-items/wp.svg",
            text: "Whatsapp",
            active: false,
            type: "whatsapp",
          },
          {
            id: 7,
            icon: "/social-items/tg.svg",
            text: "Telegram",
            active: false,
            type: "telegram",
          },
          {
            id: 8,
            icon: "/social-items/snap.svg",
            text: "Snapchat",
            active: false,
            type: "snapchat",
          },
          {
            id: 9,
            icon: "/social-items/tiktok.svg",
            text: "Tiktok",
            active: false,
            type: "tiktok",
          },
        ],
        showMoreContact: false,
      };
    });
  },
}));
